module.exports = __webpack_public_path__ + "img/10_83.65a44352.png";